<div class="one-column-page">
  <div>
    <h1 class="header-text" anessaTranslation="DROPDOWN.HELP"></h1>
    <div class="flex-container page-container">
      <div *ngFor="let document of helpDocuments" class="flexbox">
        <h3>
          {{ document.title }}
          <mat-icon
            class="clickable"
            (click)="openInNewTab(document)">
            launch
          </mat-icon>
        </h3>
        <img
          [src]="srcs[document.title]"
          alt="no cover image available"
          width="400px"
          height="550px"
          class="clickable"
          (click)="openInNewTab(document)">
      </div>
    </div>
  </div>
</div>
